// API Configuration
export const API_CONFIG = {
  GRANTS_GOV: {
    BASE_URL: 'https://www.grants.gov/grantsws/rest/opportunities/search/',
    API_KEY: import.meta.env.VITE_GRANTS_GOV_API_KEY || ''
  },
  SAM_GOV: {
    BASE_URL: 'https://api.sam.gov/opportunities/v1/search',
    API_KEY: import.meta.env.VITE_SAM_GOV_API_KEY || ''
  },
  CANDID: {
    BASE_URL: 'https://api.candid.org/v1/search',
    API_KEY: import.meta.env.VITE_CANDID_API_KEY || ''
  },
  BEEHIIV: {
    API_KEY: import.meta.env.VITE_BEEHIIV_API_KEY || '',
    PUBLICATION_ID: import.meta.env.VITE_BEEHIIV_PUBLICATION_ID || ''
  }
};